import { useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setOptions, setSearchFilters } from "../redux/slices/search.slice";
import { buildURL, buildSearchObj, processContentFilters } from '../utils/searchFunctions';
import ResultsSection from '../components/resultsSection';
import { searchResult, searchResultAppend, searchFilters } from '../redux/slices/searchActions';

export default function PublicSearch() {
  const dispatch = useDispatch();
  const abortControllerRef = useRef(null);

  const showFilterLoading = useSelector(state => state.search.showFilterLoading);
  const showResultsLoading = useSelector(state => state.search.showResultsLoading);
  const isLoadMore = useSelector(state => state.search.isLoadMore);
  const isExpandingSearch = useSelector(state => state.search.isExpandingSearch);
  const allFilters = useSelector(state => state.search.searchFilters);

  const resultsManagmentSection = [1, 2, 3, 4];

  useEffect(() => {
    const fetchSearchData = async (options) => {
      const abortControllerMain = new AbortController();
      const [updateSearchFilters, updateSearchResult] = await Promise.all([
        dispatch(searchFilters(options)).unwrap(),
        dispatch(searchResult({ data: options, signal: abortControllerMain.signal })).unwrap()
      ]);

      if (updateSearchFilters.success && updateSearchResult.success) {
        const currentFilters = JSON.parse(JSON.stringify(updateSearchFilters.data));
        const filters = processContentFilters(updateSearchResult.data, currentFilters, options);
        dispatch(setSearchFilters(filters));
      }
    };
    //Instead of getting data from base object can do ajax calls to get initial data here
    const searchParams = new URLSearchParams(window.location.search);
    const options = buildSearchObj(searchParams);
    const updateOptions = {...options, take : 12, isPublicSearch: true};
    dispatch(setOptions(updateOptions));
    fetchSearchData(updateOptions);
  }, []);

  const handleFilterChange = async (options) => {
    // Reset pagination when clearing filters
    if (!options.loadMore && !options.expandingSearch) {
      options = {
        ...options,
        skip: 0,
        take: 8
      };
    }

    // Cancel the previous request if it exists
    if (abortControllerRef.current && !options.loadMore) {
      abortControllerRef.current.abort();
    }

    // Create a new AbortController for the current request
    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    dispatch(setOptions(options));
    const urlOptions = buildURL(options);

    if (window) {
      window.history.pushState(null, null, `${window.location.pathname}${urlOptions != '' ? `?${urlOptions}` : ""}`);
    }    

    //Get data form ajax calls on changing filter data   
    try {
      let updateSearchResult = null;
      if (options.loadMore || options.expandingSearch) {
        updateSearchResult = await dispatch(
          searchResultAppend({ data: options, signal: abortController.signal })
        ).unwrap();
      }
      else {
        updateSearchResult = await dispatch(
          searchResult({ data: options, signal: abortController.signal })
        ).unwrap();
      }
  
      if (updateSearchResult.success) {
        const currentFilters = JSON.parse(JSON.stringify(allFilters));
        const filters = processContentFilters(
          updateSearchResult.data,
          currentFilters,
          options
        );
        dispatch(setSearchFilters(filters));
      }
    } catch (error) {
      // if (error.name === 'AbortError') {
      //   console.log('Previous request aborted');
      // } else {
      //   console.error('Error fetching search results:', error);
      // }
    }
  };

  return (
    <div id="maincontent">
      <div className={`resultsContainer`}>
        {showFilterLoading || showResultsLoading ? (     
          <div className="resultsManagmentSection placeholder-glow">
            <span className="resultsHeading placeholder col-2"></span>
            <div>
            {resultsManagmentSection.map((index) => (
              <div className="resultsManagmentCard" key={index}>
                <div className="resultsManagmentCardContent">
                  <div className="report-bar-icons">
                    <span className="placeholder col-4" style={{width:"4em"}}></span>
                  </div>
                  <span className="placeholder col-1 me-3"></span>
                  <span className="placeholder col-2"></span>
                  <div>
                    <div>
                      <span className="placeholder col-12 reportTitle mb-2"></span>
                      <div>
                        <span className="placeholder col-12" style={{height:"3em"}}></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              ))}
            </div>
          </div>
        ) : (
          <ResultsSection
            isLoadMore={isLoadMore}
            isExpandingSearch={isExpandingSearch}
            refreshData={handleFilterChange}
          />
        )}
      </div>
    </div>
  );
}